import { useSelector, useDispatch } from 'react-redux'
import appConfig from '../../configs/app.config'
import { REDIRECT_URL_KEY } from '../../constants/app.constant'
import { apiSignInRequest, apiSignUpRequest } from '../../services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from '../../store/auth/sessionSlice'
import { initialState, setUser } from '../../store/auth/userSlice'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import { apiGetReferralSponsor } from '../../services/RegisterService'
import { setSponsor } from '../../view/auth/register/store/dataSlice'
import registerReducer from '../../view/auth/register/store'
import { injectReducer } from '../../store'
import { getTreeData } from '../../view/Tree/store/dataSlice'
import { setList } from '../../view/list/store/dataSlice'

injectReducer('register', registerReducer)


function useAuth() {
    const dispatch = useDispatch()

    const navigate = useNavigate()

    const query = useQuery()

    const { token, signedIn } = useSelector((state) => state.auth.session)
    const userDetails = useSelector(state => state.register.data.userDetails)
    const sponsorBy = useSelector(state => state.register.data.sponsorBy)



    const signIn = async (values) => {
        try {

            const resp = await apiSignInRequest(values)
            if (resp.data) {
                const { token } = resp.data
                dispatch(onSignInSuccess(token))
                const action = await dispatch(getTreeData({ userId: resp.data?.data?._id }))
                dispatch(setList(action.payload?.data))
                if (resp.data?.data) {
                    dispatch(
                        setUser(
                            resp.data.data || {
                                avatar: '',
                                userName: 'Anonymous',
                                authority: ['USER'],
                                email: '',
                            }
                        )
                    )
                }
                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(
                    redirectUrl ? redirectUrl : (appConfig.authenticatedEntryPath)
                )
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const signUp = async (values) => {
        try {
            const value = {
                ...userDetails,
                sponsorId: sponsorBy._id,
                ...values
            }
            const {
                confirmPassword,
                ...validValue
            } = value

            const resp = await apiSignUpRequest(validValue)
            if (resp.data) {
                const { token } = resp.data
                dispatch(onSignInSuccess(token))
                const action = await dispatch(getTreeData({ userId: resp.data?.data?._id }))
                dispatch(setList(action.payload?.data))
                if (resp.data?.user) {
                    dispatch(
                        setUser(
                            resp.data.data || {
                                avatar: '',
                                userName: 'Anonymous',
                                authority: ['USER'],
                                email: '',
                            }
                        )
                    )
                }
                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(
                    redirectUrl ? redirectUrl : (appConfig.authenticatedEntryPath)
                )
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const handleSignOut = () => {
        dispatch(onSignOutSuccess())
        dispatch(setUser(initialState))
        navigate(appConfig.unAuthenticatedEntryPath)
    }

    const signOut = async () => {
        handleSignOut()
    }


    const getSponsor = async (values) => {
        try {

            const resp = await apiGetReferralSponsor(values)
            if (resp.data) {
                dispatch(setSponsor(resp.data.data))
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    return {
        authenticated: token && signedIn,
        signIn,
        signUp,
        signOut,
        getSponsor,
    }
}

export default useAuth
